import React from "react";
import DoctorHomeIntro from "./DoctorHomeIntro";
import LandscapeWhoWeAre from "./LandscapeWhoWeAre";
import ClassicWhoWeAre from "./ClassicWhoWeAre";
import CenteredPortraitWoWeAre from "./CenteredPortraitWoWeAre";
import { useSelector } from "react-redux";

function DoctorWhoWeAreWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_about === "centered-portrait" ? (
        <CenteredPortraitWoWeAre />
      ) : sitedata?.theme_about === "classic-about" ? (
        <ClassicWhoWeAre />
      ) : sitedata?.theme_about === "wide-landscape" ? (
        <LandscapeWhoWeAre />
      ) : (
        <DoctorHomeIntro />
      )}
    </>
  );
}

export default DoctorWhoWeAreWrapper;
